/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Tablet';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const TabletIcon = withMuiAdapter(Base, 'Tablet');
